<template>
  <div class="project-autopilots-add-details">
    <div class="project-autopilots-add-details-wrapper">
      <div class="project-autopilots-add-details-head">
        <!-- Page Title -->
        <TText
          :text="autopilot.function"
          font_weight="500"
          size="24"
        />

        <!-- Close Button -->
        <v-btn
          icon
          @click="$router.push({name: 'ProjectAutoPilotsAdd'})"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>

      <!-- Level Matrix -->
      <!-- NOTE: WIP -->
      <div style="display: flex; grid-gap: 8px; align-items: center;">
        <!-- {{autopilot}} -->
        <!-- NOTE: we want to change the level here, currently there is only the active level -->
        <!-- <RadioKnobRow
          :knobs="autopilot.levels"
          :selected_id="autopilot.mapped_autopilot.id"
          :cell_count="4"
          :is_disabled="!autopilot.active"
          :height="cell_height"
          :width="cell_width"
          @knobClicked="
            autopilot.mapped_autopilot.id !== level.id?
            updateUObject({
              url: [
              {projects: project.id},
              {autopilotprojects: autopilot.id}
              ],
              update: {
                ['add#autopilots']: [level.id]
              }
            }).then(() => {
              updateUObject({
                url: [
                {projects: project.id},
                {autopilotprojects: autopilot.id}
                ],
                update: {
                  ['remove#autopilots']: [autopilot.autopilots[0]]
                }
              })
              })
            :
            ''"
        /> -->

        <v-btn
          v-for="level in getUObjectsFiltered({type: 'autopilots', filter: {function: autopilot.function}})"
          :key="`aplevel${level.id}`"
          small
          class="ml-1"
          :color="autopilot.id === level.id?'green':''"
          @click="
            autopilot.id !== level.id?
            updateUObject({
              url: [
              {projects: project_id},
              {autopilotprojects: autopilotprojects.id}
              ],
              update: {
                'add#autopilots': [level.id]
              }
            }).then(() => {
              updateUObject({
                url: [
                {projects: project_id},
                {autopilotprojects: autopilotprojects.id}
                ],
                update: {
                  'remove#autopilots': [autopilotprojects.autopilots[0]]
                }
              })
              })
            :
            ''
          "
          >
          {{ level.level }}
        </v-btn>
      </div>

      <!-- Description -->
      <!-- NOTE: What do we show here? Is a simple text even enough? -->
      <TText
        :text="autopilot.description"
      />
    </div>
  </div>
</template>

<script>
import {  mapGetters, mapActions } from 'vuex';
import TText from '@/components/Taktify/TText.component.vue';
// import RadioKnobRow from '@/modules/WorkPackageWIP/RadioKnobRow.module.vue';

  export default {
    components: {
      TText,
      // RadioKnobRow,
    },

    props: [],

    data: () => ({

    }),

    computed: {
      ...mapGetters('Ultra', [
        'getUObjectsFiltered',
      ]),

      autopilot() {
        return this.$store.state.Ultra.autopilots[this.$route.params.autopilot_add_id];
      }
    },

    methods: {
      ...mapActions('Ultra', [
        'requestUObject',
        'createUObject',
        'updateUObject',
        'deleteUObject'
      ]),
    },
  }
</script>

<style>
.project-autopilots-add-details-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.project-autopilots-add-details-wrapper {
  display: flex;
  flex-direction: column;
  margin: 16px;
  grid-gap: 8px;
}
.project-autopilots-add-details {
  position: absolute;
  width: max(50%, 400px);
  height: max(50%, 400px);
  top: 25%;
  left: 25%;
  background-color: #AAA;
  border-radius: 8px;
  box-shadow: 0 0 8px 2px #0008;
}
</style>
